import { Component, OnInit } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';

@Component({
  selector: 'app-claim-process',
  templateUrl: './claim-process.component.html',
  styleUrls: ['./claim-process.component.scss']
})
export class ClaimProcessComponent implements OnInit {

  constructor(public global: GlobalComponent) { }

  ngOnInit(): void {

  }

}
